import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import BlogpostData from "../../wrappers/blog/BlogPostData.json";
import "../../assets/css/blog.css";

const BlogPostsNoSidebar = () => {
  // const { id } = useParams()
  // const blog = BlogpostData.find((item) => item.id === parseInt(id));
  // if (!blog) {
  //   return <h2>Blog not found</h2>;
  // }

  return (
    <Fragment>
      {BlogpostData.map((card, index) => {
        return (
          <div className="col-lg-6 col-md-6 col-sm-12" key={index}>
            <div className="blog-wrap-2 mb-30">
              <div className="blog-img-content">
                {/* this is static pageroute oneblogpost open old code */}
                <Link to={"/blog-details-standard"} className="blogpost_link">
                  <img
                    src={card.blogimg}
                    alt=""
                    className="blogpostimg"
                    style={{
                      width: "100%",
                      height: "400px",
                      objectFit: "cover",
                    }}
                  />
                </Link>
              </div>
              <div className="blog-content-2 mt-4">
                <h4>
                  <Link to={"/blog-details-standard"}>{card.title}</Link>
                </h4>
                <p>{card.disc}</p>
                <div className="blog-share-comment">
                  <div className="blog-btn-2">
                    <Link to={"/blog-details-standard"}>{card.link}</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </Fragment>
  );
};

export default BlogPostsNoSidebar;
